import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const targets = ref.current.querySelectorAll(".reveal-up");
    const tweens = [];
    targets.forEach((el) => {
      tweens.push(
        gsap.to(el, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 88%" },
        })
      );
    });
    ref.current.querySelectorAll(".reveal-slide").forEach((el) => {
      tweens.push(
        gsap.to(el, {
          opacity: 1,
          x: 0,
          duration: 0.9,
          ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%" },
          clearProps: "all",
          onComplete: () => el.classList.remove("reveal-slide"),
        })
      );
    });
    return () => tweens.forEach((t) => { t.scrollTrigger?.kill(); t.kill(); });
  }, []);
  return ref;
}
